<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :modal="false">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="120px">
            <el-form-item label="邮箱：" prop="mail">
                <span>{{model.mail}}</span>
            </el-form-item>
            <el-form-item label="昵称：" prop="nickname">
                <span>{{model.nickname}}</span>
            </el-form-item>
            <el-form-item label="中奖倍率：" prop="winning_rate">
                <span>{{model.winning_rate}}</span>
            </el-form-item>
            <el-form-item label="邀请人数：" prop="invite_count">
                <span>{{model.invite_count}}</span>
            </el-form-item>
            <el-form-item label="参与时间：" prop="add_time">
                <span>{{model.add_time}}</span>
            </el-form-item>
            <el-form-item label="是否中奖：" prop="is_winning">
                <el-select clearable v-model="model.is_winning" placeholder="请选择">
                    <el-option v-for="item in enuObj('winning_state')" :key="'winning_state'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="备注：" prop="remark">
                <el-input type="textarea" rows="3" v-model="model.remark"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" size="medium">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'raffleUserEdit',
    mixins: [editutil],
    data() {
        return {
            model: {
                raffle_id: '',
                member_id: '',
                mail: '',
                nickname: '',
                face: '',
                winning_rate: '',
                invite_count: '',
                is_winning: '',
                remark: '',
                add_time: '',
            },
            getObj:{
                url:'/api/admin/raffle/userInfo',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: ['winning_state'],
            rules: {
                is_winning: [
                    {required: true, message: '是否中奖不能为空', trigger: 'blur'}
                ],
            },
        };
    },
    methods: {
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/raffle/userSave'
                    }
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
        formateData(){
            this.model.is_winning = this.model.is_winning+""
        },
    }
};
</script>